import React from "react";
import {
    FormGroup,
    InputGroup,
    Dialog,
    Classes,
    Intent,
    Button,
} from "@blueprintjs/core";
import Session from '../../../services/Session'

class DialogAddAttribute extends React.Component {

    state = {
        name: '',
        unit: '',
        ref: Math.floor(Math.random() * 600000000) + 1
    }

    addAttribute = async () => {
        const upDatedAttributes = [...this.props.attributes, { name: this.state.name, ref: this.state.ref, unit: this.state.unit }]
        await Session.addCustomAttribute(upDatedAttributes)
        this.props.refreshAttributesList()
        this.props.onCloseDialog()
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    render() {
        const {
            dialogIsOpen,
            submiting,
            onCloseDialog,
        } = this.props;

        const { name, unit } = this.state

        return (
            <Dialog
                // icon="cloud-upload"
                title="Add custom attribute"
                autoFocus={true}
                canEscapeKeyClose={true}
                canOutsideClickClose={true}
                usePortal={true}
                enforceFocus={true}
                isOpen={dialogIsOpen}
                onClose={onCloseDialog}
            >
                <div className={Classes.DIALOG_BODY}>
                    <FormGroup label="Name of the attribute" labelFor="feedback-question">
                        <InputGroup
                            id="feedback-question"
                            name="name"
                            // disabled={feedback.type === "UNK" || feedback.type == null}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup label="Unit of the attribute" labelFor="feedback-question">
                        <InputGroup
                            id="feedback-question"
                            name="unit"
                            // disabled={feedback.type === "UNK" || feedback.type == null}
                            onChange={this.handleChange}
                        />
                    </FormGroup>

                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            onClick={onCloseDialog}
                            text="Cancel"
                            disabled={submiting}
                        />
                        <Button
                            onClick={this.addAttribute}
                            text="Add"
                            intent={Intent.SUCCESS}
                            rightIcon="cloud-upload"
                            disabled={
                                name === "" ||
                                unit === ''
                            }
                        // loading={submiting}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default DialogAddAttribute;
